import React, { ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { breadcrumbRouteUsers } from 'modules/User/breadcrumbs';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import UserTable from 'modules/User/container/Table';
import UserFilter from 'modules/User/container/Filter';
import UserPagination from 'modules/User/container/Pagination';
import UserPerPage from 'modules/User/container/PerPage';
import User from 'modules/User/model/User';
import { createSearchingProps } from 'modules/Shared/helper/params';
import {
  setUserListParamsAction,
  SetUserListParamsAction
} from 'modules/User/action/list';
import { RootState } from 'app/reducer';

export interface StateProps {
  fetching: boolean;
  type: string;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (payload: PartialSearchingProps) => SetUserListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setUserListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.user.list;
  const { type } = state.layout.page;

  return { fetching, type };
};

export class UsersListView extends React.Component<Props> {
  protected searchProps: SearchingProps;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      User.getFilterableAttributes(),
      User.getSortableAttributes(),
      { sort: 'created_at', sort_method: 'desc' }
    );
  }

  componentDidMount(): void {
    const { managePage, setParams } = this.props;

    managePage({
      title: 'Users',
      breadcrumb: breadcrumbRouteUsers()
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { filter } = this.searchProps;
    const { fetching, type } = this.props;

    if (type) return null;

    return (
      <div className="row users-view">
        <div className="col-12">
          <Listing
            table={<UserTable />}
            filter={<UserFilter values={filter} />}
            pagination={<UserPagination />}
            perPage={<UserPerPage />}
            loading={fetching}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(UsersListView);
